'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getInstanceClient } from '../../../../di/entry.browser.js';
import { DefinitionEntity } from '../../../../domain/entry.js';
import { drawResultQueryKeys } from '../../../../lib/entry.js';
import { useDraw } from './useDraw.js';
/**
 * Hook to get subscribed draw forecast.
 *
 * @param drawQueryOptions Props for draw results
 * @param drawQueryOptions.product - The product for which to get the draw forecast.
 * @param drawQueryOptions.drawNumber - The draw number to get the forecast for.
 * @param options Options object
 * @param options.skip conditionally skip subscribe
 */
export function useSubscribedDrawForecast(t0, options) {
  const $ = _c(12);
  const {
    product,
    drawNumber
  } = t0;
  const queryClient = useQueryClient();
  const isSkipped = options?.skip ?? false;
  let t1;
  if ($[0] !== drawNumber || $[1] !== product) {
    t1 = {
      product,
      drawNumber
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: drawData
  } = useDraw(t1);
  let t2;
  if ($[3] !== drawData.draw.drawState.client) {
    t2 = DefinitionEntity.hasDrawForecast(drawData.draw.drawState.client);
    $[3] = drawData.draw.drawState.client;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isDrawLiveOrFinalized = t2;
  let t3;
  let t4;
  if ($[5] !== drawNumber || $[6] !== isDrawLiveOrFinalized || $[7] !== isSkipped || $[8] !== product || $[9] !== queryClient) {
    t3 = () => {
      if (!isDrawLiveOrFinalized || isSkipped) {
        return _temp;
      }
      const controller = getInstanceClient("ISubscribeDrawForecastController");
      const queryKeys = drawResultQueryKeys.result(product, drawNumber);
      const unsubscribedDrawForecast = controller({
        product,
        drawNumber
      }, nextData => {
        queryClient.setQueryData(queryKeys, () => nextData);
      });
      return unsubscribedDrawForecast;
    };
    t4 = [product, drawNumber, queryClient, isDrawLiveOrFinalized, isSkipped];
    $[5] = drawNumber;
    $[6] = isDrawLiveOrFinalized;
    $[7] = isSkipped;
    $[8] = product;
    $[9] = queryClient;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  useEffect(t3, t4);
}
function _temp() {}